import React from 'react'
import {DefaultProps, RefTable, Validator} from "./RefTable";


export const MonthlyLastDayExchangeRates = (props)=><RefTable {...props}/>;



MonthlyLastDayExchangeRates.defaultProps = {
    ...DefaultProps,
    tableName: "exchange_rates_per_month",
    tableSchema: "exchange_rates_per_month",
    edit: true,
    title: "Month-Last Day Exchange Rates",
    theadHeight: 40,
    validator: {
        to_eur_rate: new Validator("to_eur_rate", async (value)=> {
            if(value <= 0 )
                return Promise.reject("Exchange rate cannot be zero or negative")
        })
    },
}
